import * as types from "@/store/mutation-types";

const state = {
  storage: {}
}

const actions = {
  addStorage({commit}, storage) {
    commit(types.FETCH_STORAGE_SUCCESS, storage)
  }
}

const mutations = {
  [types.FETCH_STORAGE_SUCCESS] (state, storage) {
    state.storage = storage
  }
}

const getters = {
  storage: state => state.storage
}

export default {
  state,
  actions,
  mutations,
  getters,
}